import { BookClockIcon } from './BookClockIcon';

/**
 * author: Colton Wiscombe
 * id 97CCD006-4DE0-4AEE-BB95-D9EBCCDE8012
 * name book-clock
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-clock.svg
 * tags
 * - Date / Time 
 */
export const BookTimeIcon = BookClockIcon;
export default BookTimeIcon